export default __webpack_public_path__ + "static/media/Acharya.fd262b7e.jpg";